<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<div id="mainContainer" [ngClass]="{'menu-slide': addSlideCls,'wbx-main-with-admin-masquerade': showMasqueradeOverlay, 'wbx-add-challenge-bar': addChallengeBarActive, 'show-wbx-menu': showWbxMenu}">
  @if (showMasqueradeOverlay) {
  <div class="wbx-user-masquerade-overlay">
            <div class="wbx-full-container">
                <div class="wbx-user-masquerade-row">
                    <div class="wbx-user-masquerade-contant">
                        <p>{{ masqueradeOverlayText }}</p>
                    </div>
                    <div class="wbx-user-masquerade-exit">
                        <button
                          type="button"
                          class="wbx-user-masquerade-exit-btn"
                          (click)="onExitAdminPanelClick($event)"
                        >
                            {{ translations.GLOBAL.KEYS.EXIT_BUTTON | translate }}
                        </button>
                    </div>
                </div>
            </div> 
        </div>
  }
  <ngx-loading-bar color="#55d2ff" [includeSpinner]="false" height="3px"></ngx-loading-bar>
  @if (!isOnline) {
    <div class="offline-message-section">
      <div class="offline-message-section-inner">
        <i><svg width="126" height="105" viewBox="0 0 126 105" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M103.688 104.15L54.3375 54.5377C50.225 55.5002 46.3978 56.9439 42.8558 58.8689C39.3138 60.7939 36.141 63.2002 33.3375 66.0877L22.3125 54.8002C25.1125 52.0002 28.1313 49.5502 31.3687 47.4502C34.6063 45.3502 38.0625 43.5127 41.7375 41.9377L29.925 30.1252C26.3375 31.9627 22.9897 33.9979 19.8818 36.2309C16.7738 38.4639 13.8215 40.9787 11.025 43.7752L0 32.4877C2.8 29.6877 5.71025 27.1729 8.73075 24.9434C11.7513 22.7139 14.966 20.5912 18.375 18.5752L7.35 7.55019L14.7 0.200195L111.3 96.8002L103.688 104.15ZM63 95.7502C59.325 95.7502 56.2188 94.4587 53.6813 91.8757C51.1438 89.2927 49.875 86.2092 49.875 82.6252C49.875 78.9502 51.1438 75.8439 53.6813 73.3064C56.2188 70.7689 59.325 69.5002 63 69.5002C66.675 69.5002 69.7812 70.7689 72.3187 73.3064C74.8562 75.8439 76.125 78.9502 76.125 82.6252C76.125 86.2127 74.8562 89.298 72.3187 91.881C69.7812 94.464 66.675 95.7537 63 95.7502ZM93.975 64.5127L90.1687 60.7064L86.3625 56.9002L67.4625 38.0002C74.55 38.7002 81.1772 40.4939 87.3442 43.3814C93.5112 46.2689 98.959 50.0752 103.688 54.8002L93.975 64.5127ZM114.975 43.7752C108.237 37.0377 100.427 31.7667 91.5443 27.9622C82.6613 24.1577 73.1465 22.2537 63 22.2502C61.1625 22.2502 59.3915 22.3167 57.687 22.4497C55.9825 22.5827 54.2535 22.7787 52.5 23.0377L39.1125 9.6502C42.9625 8.60019 46.879 7.8127 50.862 7.2877C54.845 6.7627 58.891 6.5002 63 6.5002C75.425 6.5002 87.0188 8.81894 97.7812 13.4564C108.544 18.0939 117.95 24.4377 126 32.4877L114.975 43.7752Z" fill="black"/>
        </svg></i>
        <h1>{{translations.GLOBAL.KEYS.NO_INTERNET_CONNECTION_MESSAGE | translate }}</h1>
      </div>
    </div>
  }

  @if (currentUrl && currentUrl === 'delete-account-request') {
    @if (isOnline) {
      <div>
        <router-outlet></router-outlet>
      </div>
    }
  } @else {
    @if (isOnline) {
      <div>
        @if (showAdminHeader) {
          <app-header></app-header>
        }
        @if (showUserHeader) {
          <app-user-header></app-user-header>
        }

        <router-outlet></router-outlet>
        <!-- For Future usage when folds come into picture -->
        <!--<div class="mid-container">
        <div *ngFor="let f of fold">
          <div appFrontFactory comp="{{f.foldType.frontComponent}}" foldData="{{f.data}}" userData="{{userData}}"></div>
        </div>
      </div>-->
      <app-footer></app-footer>
    </div>
  }
}

<app-custom-toast-message></app-custom-toast-message>
<app-custom-confirmation-popup></app-custom-confirmation-popup>

</div>

